<template>
    <Card>
        <FetchTable :handle="tableHandle" :url="table.url" :columns="table.columns" v-model:orders="table.orders">
            <template #td-name="{row}">
                {{ row.warehouse.name }}
            </template>
            <template #td-balance="{row}">
                {{ Amount.factory(row.balance_with_reserve).toMeasurementString(product.measurement) }}
            </template>
            <template #td-reserve="{row}">
                {{ Amount.factory(row.reserve).toMeasurementString(product.measurement) }}
            </template>
            <template #td-waiting="{row}">
                {{ Amount.factory(row.waiting).toMeasurementString(product.measurement) }}
            </template>
            <template #td-available="{row}">
                {{ Amount.factory(row.balance).toMeasurementString(product.measurement) }}
            </template>
            <template #tfoot>
                <tr>
                    <th><div>{{ $t('labels.total') }}:</div></th>
                    <th><div class="d-flex justify-content-end">{{ Amount.factory(tableHandle.meta.total_balance_with_reserve ?? 0).toMeasurementString(product.measurement) }}</div></th>
                    <th><div class="d-flex justify-content-end">{{ Amount.factory(tableHandle.meta.total_reserve ?? 0).toMeasurementString(product.measurement) }}</div></th>
                    <th><div class="d-flex justify-content-end">{{ Amount.factory(tableHandle.meta.total_balance ?? 0).toMeasurementString(product.measurement) }}</div></th>
                    <th><div class="d-flex justify-content-end">{{ Amount.factory(tableHandle.meta.total_waiting ?? 0).toMeasurementString(product.measurement) }}</div></th>
                    <th></th>
                </tr>
            </template>
            <template #td-updated_at="{row}" >
                <Button color="teal" @click="$refs.movingModal.show(row.warehouse_uuid)">
                    {{ DateFormatter.formatDateTime(row.updated_at) }}
                </Button>
            </template>
        </FetchTable>
    </Card>
    <MovingModal ref="movingModal" :product="product"/>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import FetchTable from '../../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../../components/new/table/tableHandle';
import Amount from '../../../../../services/Amount.ts';
import MovingModal from "../modals/MovingModal.vue";
import Button from "../../../../../components/new/button/AlphaBackgroundButton.vue";
import DateFormatter from "../../../../../services/DateFormatter.ts"
export default {
    name: "InternalProductAvailabilityPage",
    components: {
        Card, FetchTable, MovingModal, Button
    },
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            Amount: Amount,
            table: {
                url: '/management/warehouses/products/availability',
                orders: [],
                columns: [
                    {key: 'name', name: this.$t('table.titles.warehouse'), width: 'auto', type: 'string', order: false},
                    {key: 'balance', name: this.$t('table.titles.balance'), width: '200px', type: 'number', order: false},
                    {key: 'reserve', name: this.$t('table.titles.reserve'), width: '200px', type: 'number', order: false},
                    {key: 'available', name: this.$t('table.titles.available'), width: '200px', type: 'number', order: false},
                    {key: 'waiting', name: this.$t('table.titles.waiting'), width: '200px', type: 'number', order: false},
                    {key: 'updated_at', name: this.$t('table.titles.last_move_updated_at'), width: '300px', type: 'number', order: true},
                ]
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows({product_uuids: [this.product.uuid]})
    }
}
</script>